import { createContext, useContext, useState } from "react";

const pharmacyContext = createContext();

export const PharmacyProvider = (props) => {
	const [currentLab, setCurrentLab] = useState(() => {
			const saved = localStorage.getItem('currentLab');
			return saved ? JSON.parse(saved) : null;
		});

		return (
			<pharmacyContext.Provider value={{ ...props, currentLab, setCurrentLab}}>
				{props.children}
			</pharmacyContext.Provider>
		)
}

export const useLab = () => useContext(pharmacyContext);